var base = require('kiosk/kiosk');

Vue.component('spark-kiosk', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/kiosk/kiosk.js